import { nanoquery } from '@nanostores/query'
import { getAgentClient } from '../client-services/get-agent'
import type { AgentUser } from '../../models/AgentUser'

export const [createAgentFetcherStore, createAgentMutatorStore] = nanoquery({
  fetcher: async (..._keys: (string | number | boolean)[]): Promise<AgentUser | undefined> => {
    const agentData = sessionStorage.getItem('agentData')
    const agentDataObj = agentData ? JSON.parse(agentData) : undefined

    if (!agentDataObj || !agentDataObj.agentMode) {
      return undefined
    }

    return { ...(await getAgentClient()), profileId: agentDataObj.profileId }
  },
})

export const updateAgent = createAgentMutatorStore(async ({ getCacheUpdater }) => {
  const [updateCache, agentData] = getCacheUpdater(`agent`)
  updateCache(agentData)
  return
})
